/**
 * Pulls a sentence out of whatever shape the API refused with.
 *
 * Two shapes arrive. Ours is `{ message }` and is already written for a
 * person. Elysia's schema validator is not — it refuses before the handler
 * runs and reports `"body.file" has invalid file type`, which is true and
 * useless. Those get replaced, not surfaced.
 */
export function messageOf(value: unknown, fallback: string): string {
  if (!value || typeof value !== "object") return fallback;

  if ((value as { type?: unknown }).type === "validation") {
    const on = (value as { property?: unknown }).property;
    if (on === "body.file") {
      return "That file was refused: it must be a PDF of 5MB or less.";
    }
    return fallback;
  }

  const m = (value as { message?: unknown }).message;
  return typeof m === "string" && m ? m : fallback;
}

/** The same, for a treaty result that has already been destructured. */
export function throwOn(
  error: { status: number; value: unknown } | null,
  fallback: string,
): void {
  if (error) throw new Error(messageOf(error.value, fallback));
}
